import i18n from 'i18next';
import React from 'react';
import useStyles from './NotFoundPage.styles';

const NotFoundPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <h2 className={classes.error}>{i18n.t('common.message.pageNotFound')}</h2>
      <p className={classes.message}>{i18n.t('common.message.technicalSupport')}</p>
    </div>
  );
};

export default NotFoundPage;
